import { render, staticRenderFns } from "./privateChat.vue?vue&type=template&id=71625446&"
import script from "./privateChat.vue?vue&type=script&lang=js&"
export * from "./privateChat.vue?vue&type=script&lang=js&"
import style0 from "./privateChat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports